import { LeftRightBasedExpression } from './LeftRightBasedExpression.js';
export class OperationCallExpression extends LeftRightBasedExpression {
    constructor(operator, left, right) {
        super(left, right);
        this.operator = operator;
    }
    getOperator() {
        return this.operator;
    }
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        if (this.getOperator() === Operator.NOT_EQUAL) {
            return left !== right;
        }
        else if (this.getOperator() === Operator.LESS_EQUAL_THAN) {
            return left <= right;
        }
        else if (this.getOperator() === Operator.GREATER_EQUAL_THAN) {
            return left >= right;
        }
        else if (this.getOperator() === Operator.GREATER_THAN) {
            return left > right;
        }
        else if (this.getOperator() === Operator.LESS_THAN) {
            return left < right;
        }
        else if (this.getOperator() === Operator.EQUAL) {
            return left === right;
        }
    }
}
export var Operator;
(function (Operator) {
    Operator["NOT_EQUAL"] = "<>";
    Operator["LESS_EQUAL_THAN"] = "<=";
    Operator["GREATER_EQUAL_THAN"] = ">=";
    Operator["GREATER_THAN"] = ">";
    Operator["LESS_THAN"] = "<";
    Operator["EQUAL"] = "=";
})(Operator || (Operator = {}));
//# sourceMappingURL=OperationCallExpression.js.map